// containers/CharacterViewer.tsx
import { useState, useEffect } from "react";
import CharacterDrawer from "./CharacterDrawer";
import { CharacterType } from "./Character";
import { getCharacter } from "../../../services/characterRequests";

export default function CharacterViewer({
  minimalCharacter,
  onClose,
}: {
  minimalCharacter: { ID: string };
  onClose(): void;
}) {
  const [isLoading, setIsLoading] = useState(true);
  const [character, setCharacter] = useState<CharacterType | null>(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!minimalCharacter) return;

    setIsLoading(true);
    setOpen(true);

    (async () => {
      try {
        const full = await getCharacter(minimalCharacter.ID);
        setCharacter(full);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [minimalCharacter]);

  const handleClose = () => {
    setOpen(false);
    onClose();
  };

  return (
    <CharacterDrawer
      open={open}
      onClose={handleClose}
      character={character}
      isLoading={isLoading}
    />
  );
}
